<template>
  <ui-field
    :id="id"
    :label="label"
    :variant="variant"
    :error="error"
    :labelPosition="labelPosition"
    :bottom-margin="bottomMargin"
  >
    <ui-range-input
      :id="id"
      :readonly="readonly"
      :value="value"
      :required="required"
      :min="min"
      :max="max"
      :step="step"
      v-on="$listeners"
    />
  </ui-field>
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
    type: { type: String, default: "text" },
    label: String,
    variant: {
      type: String,
      validator: val => ["default", "success", "error"].includes(val),
      default: "default"
    },
    error: String,
    labelPosition: String,
    bottomMargin: { type: String },
    value: [String, Number],
    min: [String, Number],
    max: [String, Number],
    step: [String, Number],
    readonly: [String, Boolean],
    required: [String, Boolean]
  },
  data() {
    return {
      dirty: false,
      modified: false,
      submitted: false
    };
  },
  computed: {
    dirtyError() {
      if (this.dirty || this.submitted) {
        return this.error;
      } else {
        return null;
      }
    },
    inputListeners() {
      return {
        ...this.$listeners,
        input: event => {
          this.modified = true;
          this.$emit("input", event);
        },
        blur: event => {
          if (this.modified) {
            this.dirty = true;
          }
          this.$emit("blur", event);
        }
      };
    }
  },
  methods: {
    onFormSubmit() {
      this.submitted = true;
    }
  },
  mounted() {
    this.form = this.$el.closest("form");
    this.form?.addEventListener("submit", this.onFormSubmit);
  },
  beforeDestroy() {
    this.form?.removeEventListener("submit", this.onFormSubmit);
  }
};
</script>
